import React from 'react';

export default () => <svg width="100px" height="100px"
    viewBox="0 0 100 100" >
    <polygon class="fil1" points="82.85,62.04 45.18,62.04 45.18,47.77 26.58,58.5 7.99,69.24 26.58,79.98 45.18,90.71 45.18,76.44 82.85,76.44 " />
    <polygon class="fil2" points="54.82,52.23 73.42,41.5 92.01,30.76 73.42,20.02 54.82,9.29 54.82,23.56 17.15,23.56 17.15,37.96 54.82,37.96 " />
</svg>